module.exports = __webpack_public_path__ + "img/backup.7caba236.svg";